import { Strategy } from 'utility-ts-strategy';

export interface IAPApiUrlStrategy {
  url: string;
}
export const APApiUrlStrategy = new Strategy<IAPApiUrlStrategy>({});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/ap_api_url_strategy.ts